module.exports = __webpack_public_path__ + "static/RobotoMono-Regular-d8ebf142d841dbfb786534aaf0dec020.woff";